import { AddressAddComponent } from 'src/app/profile/addresses/address-add/address-add.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AddressService } from 'src/app/services/address.service';
import { StoreService } from 'src/app/services/stores.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ALSUPER_TYPE } from '../../utils';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { OrderService } from 'src/app/services/order.service';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { INearStores } from '@models/store.model';
import { IReferenceAddress } from '@models/address.model';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DecimalPipe } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, MatProgressBarModule, MatIconModule, MatDialogModule, MatRippleModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatProgressSpinnerModule, DecimalPipe, TranslateModule, NgxMaskDirective]
})
export class DeliveryComponent implements OnInit {

  public isPickup = false;
  public tempAddress: any;
  public latitude: number;
  public longitude: number;
  public selectedOption = '';
  public addresses: any[] = [];
  public tempAddressStore: any;
  public selectedStoreType = '';
  public nearStores: INearStores[] = [];
  public storeType = ALSUPER_TYPE;
  public displayAvailableStores = false;
  public referenceAddress: IReferenceAddress = {};
  public storesLoading = false;
  public zipCodeForm = new FormControl<string>(JSON.parse(localStorage.getItem('address') || '{}').zipCode, [Validators.required]);

  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  public loadingText = 'Buscando sucursales';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialog: MatDialog,
    private cartService: CartService,
    private storeServices: StoreService,
    private addressService: AddressService,
    private dialogRef: MatDialogRef<DeliveryComponent>,
    private orderService: OrderService,
    private geocodingService: GeocodingService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.isPickup = this.data ? true : false;
    if (this.isPickup) {
      this.selectedOption = 'pickup';
    }
    try {
      if (this.selectedOption === 'pickup' && this.data.coords) {
        this.storesLoading = true;
        this.referenceAddress = this.data.address;
        this.latitude = this.data.coords.lat;
        this.longitude = this.data.coords.lng;
        const { data } = await this.storeServices.getNearPickupStores(this.latitude, this.longitude);
        this.nearStores = data;
        this.storesLoading = false;
        this.displayAvailableStores = !this.displayAvailableStores;
      }
    } catch (error) {
      this.nearStores = [];
      this.storesLoading = false;
      this.displayAvailableStores = !this.displayAvailableStores;
    }
  }

  public async getAddresses(): Promise<void> {
    this.addresses = [];
    try {
      const { data } = await this.addressService.getAddresses();
      this.addresses = data;
      for (const item of this.addresses) {
        if (item.default) {
          this.referenceAddress = item;
          const [lat, lng] = this.referenceAddress.coordinates ?? [0, 0];
          if (lat !== 0) this.latitude = lat;
          if (lng !== 0) this.longitude = lng;
        }
      }
    } catch (error) { }
  }

  public async onSelectingOption(option: string): Promise<void> {
    this.selectedOption = option;
  }

  public async continue(): Promise<void> {
    if (this.selectedOption === 'delivery') {
      await this.getAddresses();
      if (this.addresses.length) {
        this.dialogRef.close({ status: true, pickup: false });
      } else {
        this.dialog.open(AddressAddComponent, {
          width: '500px',
          disableClose: true
        }).afterClosed().subscribe((res: any) => {
          this.selectedOption = '';
          if (res.data) {
            this.dialogRef.close({ status: true, pickup: false });
          }
        });
      }
    } else {
      this.onSettingPickupType();
    }
  }

  public async onSettingPickupType(): Promise<void> {
    this.nearStores = [];
    if (this.tempAddress) {
      this.latitude = this.tempAddress[0];
      this.longitude = this.tempAddress[1];
    }
    this.storesLoading = true;
    try {
      if (this.zipCodeForm.value) this.referenceAddress.zipcode = this.zipCodeForm.value;
      const { results } = await this.geocodingService.geocoding(`Mexico, ${this.zipCodeForm.value}`);
      const lat = results[0].geometry.location.lat;
      const lng = results[0].geometry.location.lng;
      const { data } = await this.storeServices.getNearPickupStores(lat, lng);
      this.nearStores = data;
      this.storesLoading = false;
      this.displayAvailableStores = true;
    } catch (error) {
      this.nearStores = [];
      this.storesLoading = false;
      this.displayAvailableStores = true;
    }
  }

  public getAddressDelivery(place: any): void {
    this.tempAddress = place;
  }

  public toLogin(): void {
    this.router.navigate(['autenticacion/iniciar-sesion']);
  }

  public setDefaultAddress(store: INearStores): void {
    const addressJSON = {
      type: 'pickup',
      displayName: store.name,
      store: store.branch_id
    };
    this.tempAddressStore = addressJSON;
  }

  public async onSettingAddress(): Promise<void> {
    try {
      await this.cartService.onSettingPickupAddress({
        branch_id: this.tempAddressStore.store
      });
      const { data } = await this.cartService.onGettingCartListDirect();
      if (data.tips > 0) {
        await this.orderService.onAddingTip({ amount: 0 });
      }
      localStorage.setItem('address', JSON.stringify(this.tempAddressStore));
      this.dialogRef.close({ status: true, pickup: true });
    } catch (error) { }
  }

  public goBack(): void {
    if (this.data?.coords) {
      this.dialogRef.close({ status: true, pickup: true });
    } else {
      this.displayAvailableStores = !this.displayAvailableStores;
      this.nearStores = [];
    }
  }

  public changeAddress(): void {
    this.displayAvailableStores = !this.displayAvailableStores;
    this.nearStores = [];
  }
}
